export const AccountantActionTypes = {
    ACCOUNTANT_LIST_GET: 'ACCOUNTANT_LIST_GET',
    ACCOUNTANT_LIST_GET_SUCCESSFUL: 'ACCOUNTANT_LIST_GET_SUCCESSFUL',
    ACCOUNTANT_LIST_GET_ERROR: 'ACCOUNTANT_LIST_GET_ERROR',

    SET_ACCOUNTANT_QUERY: 'SET_ACCOUNTANT_QUERY',
    RESET_ACCOUNTANT_QUERY: 'RESET_ACCOUNTANT_QUERY'
}
